import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { IPerson, selectPersonLoggedIn } from '../../../store/slices/auth';
import {
  createCustomerChat,
  //  getLocationCustomers,
  //  selectLocationCustomers
} from '../../../store/slices/chat';
import classes from './Inbox.module.scss';
import { fetchCustomers, ICustomer, selectCustomers } from '../../../store/slices/customers';
import { getFullNameInitials } from '../../../helpers';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  onClose: () => void;
};

const ModalComponent: React.FC<Props> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();

  const personLoggedIn = useAppSelector<IPerson>(selectPersonLoggedIn);
  const customers = useAppSelector<ICustomer[]>(selectCustomers);
  const [filteredData, setFilteredData] = useState<Array<any>>([]);

  useEffect(() => {
    if (customers.length <= 0) dispatch(fetchCustomers());
  }, [dispatch]);

  useEffect(() => {
    if (customers.length > 0) setFilteredData(customers);
  }, [customers]);

  const handleCreateChat = async (customer: any) => {
    const obj = {
      conversation_name: translations('conversation_default_name'),
      conversation_title: translations('conversation_default_title'),
      conversation_type: 'support',
      participants: [
        {
          participant_person_id: Number(personLoggedIn.person_external_id),
          participant_name: personLoggedIn.person_firstname,
          participant_last_name: personLoggedIn.person_lastname,
          assigned_as: 'A',
        },
        {
          participant_person_id: Number(customer.person_external_id),
          participant_name: customer.person_firstname,
          participant_last_name: customer.person_lastname,
          assigned_as: 'C',
        },
      ],
    };
    await dispatch(createCustomerChat(obj));
    onClose();
  };

  const handleSearch = (e: any) => {
    let value = e.target.value.toLowerCase();
    const filteredData = customers.filter((el: any) => {
      const fullName = `${el.person_firstname} ${el.person_lastname}`;
      //if no input the return the original
      if (value === '') return el;
      //return the item which contains the user input
      else return fullName.toLowerCase().includes(value);
    });
    setFilteredData(filteredData);
  };

  return (
    <div className={classes.customersModal}>
      <div className={classes.searchBar}>
        <i className={classes.searchIcon} />
        <input onChange={handleSearch} placeholder={translations('search_placeholder')} />
      </div>
      {filteredData?.map((customer: any, index: number) => {
        return (
          <div
            className={classes.customerItem}
            onClick={() => handleCreateChat(customer)}
            key={index}
          >
            <div className={classes.icon}>
              <div className={classes.avatar}>
                {getFullNameInitials(`${customer.person_firstname} ${customer.person_lastname}`)}
              </div>
            </div>
            <div className={classes.info}>
              <p className={classes.title}>
                {`${customer.person_firstname} ${customer.person_lastname}`}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ModalComponent;
